import Alert from '@jbhi-fi/lanyard-ui/components/Alert/Alert';
import alertType from '@jbhi-fi/lanyard-ui/components/Alert/types/alert.type';
import React from 'react';
import { Document } from '@contentful/rich-text-types';
import { RichText } from '../../RichText';
import { styles } from './InfoModule.css';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';

export type InfoModuleProps = {
  className?: string;
  heading: string;
  content?: Document;
  type?: alertType;
};

export const InfoModule = ({ heading, content, type = 'info', className }: InfoModuleProps) => {
  return (
    <Alert heading={heading} type={type} showIcon inline classes={classNames(styles.container, className)}>
      {content ? <RichText document={content} containerClass={styles.content} /> : null}
    </Alert>
  );
};
